module.exports = __webpack_public_path__ + "static/img/service-04.3a0876ea.png";